import React from 'react';
import { Input } from '@hiring-intelligence/ui';

interface LocationSelectProps {
	value: string;
	onChange: (value: string) => void;
	className?: string;
	placeholder?: string;
	required?: boolean;
}

const COMMON_LOCATIONS = [
	'Global',
	'Remote (Worldwide)',
	'Remote (APAC)',
	'Remote (EMEA)',
	'Remote (Americas)',
	'Indonesia',
	'Singapore',
	'Malaysia',
	'Thailand',
	'Vietnam',
	'Philippines',
	'India',
	'United States',
	'United Kingdom',
	'Australia',
	'Germany',
	'Canada',
	'Netherlands',
	'Japan',
	'South Korea',
	'China',
	'Hong Kong',
	'Taiwan',
	'France',
	'Spain',
	'Brazil',
	'Mexico',
	'United Arab Emirates'
];

export function LocationSelect({ value, onChange, className, placeholder = "Select or type location...", required }: LocationSelectProps) {
	return (
		<>
			<Input
				list="location-options"
				value={value || ''}
				onChange={(e) => onChange(e.target.value)}
				className={className}
				placeholder={placeholder}
				required={required}
			/>
			<datalist id="location-options">
				{COMMON_LOCATIONS.map((loc) => (
					<option key={loc} value={loc} />
				))}
			</datalist>
		</>
	);
}
